<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import IllustrationEmptyList from '~icons/illustration/empty-list'

interface Props {
  headingTag?: 'h3' | 'h4'
}

withDefaults(defineProps<Props>(), {
  headingTag: 'h3',
})

const { t } = useI18n()
</script>

<template>
  <div class="my-wallet-empty">
    <IllustrationEmptyList class="my-wallet-empty-image" aria-hidden="true" />
    <div class="my-wallet-empty-text">
      <component :is="headingTag" class="my-wallet-empty-title">
        {{ t('my_wallet.empty.title') }}
      </component>
      <p class="my-wallet-empty-description">
        {{ t('my_wallet.empty.description') }}
      </p>
    </div>
  </div>
</template>

<style scoped lang="scss">
.my-wallet-empty {
  @apply flex flex-col items-center gap-6 py-8 mx-auto text-center;
  max-width: 550px;

  .my-wallet-empty-image {
    @apply w-24 h-24;
  }

  .my-wallet-empty-text {
    @apply flex flex-col gap-2;
  }

  .my-wallet-empty-title {
    @apply fonts-heading-h4 text-neutral-low-pure;
  }

  .my-wallet-empty-description {
    @apply fonts-body-large-regular text-neutral-low-light;
  }
}
</style>
